import { DeleteEmailTemplateMeta, DeleteEmailTemplatePayload } from 'types/store/DeleteEmailTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { deleteEmailTemplateActions } from '../actions';

export default createAsyncReducer<DeleteEmailTemplateMeta, DeleteEmailTemplatePayload>(deleteEmailTemplateActions);
